var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["HTML5Backend"]: () => __WEBPACK_EXTERNAL_MODULE_react_dnd_html5_backend_1abf4d9b__.HTML5Backend });